function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function findFailedRequest(results) {
    return results.find((result)=>!result.success);
}
// This function stitches the results of multiple requests into a single result.
// It also nullifies the whole data in two cases:
// 1) Any of the sublinks containing non-nullable fields return GraphQL errors.
// 2) Any of the sublinks returns a network, 5xx or a client error
// This is to mimic the future behavior of a GraphQL gateway.
export default function stitchSubLinksResults(results) {
    const failedRequest = findFailedRequest(results);
    if (failedRequest) {
        return {
            success: false,
            error: failedRequest.error
        };
    }
    let resultData = {};
    let resultErrors = [];
    let shouldNullifyData = false;
    results.forEach((result)=>{
        if (!result.success) {
            // This shouldn't happen since we already checked for failed requests
            // but it's needed to make TypeScript happy
            return;
        }
        const { linkResult, extensions } = result;
        const { data, errors } = linkResult;
        if (data) {
            resultData = _object_spread({}, resultData, data);
        }
        if (errors) {
            resultErrors = [
                ...resultErrors,
                ...errors
            ];
            const containsNonNullableFields = extensions === null || extensions === void 0 ? void 0 : extensions.containsNonNullableFields;
            if (containsNonNullableFields) {
                shouldNullifyData = true;
            }
        }
    });
    const result = {
        data: shouldNullifyData ? null : resultData,
        errors: resultErrors.length > 0 ? resultErrors : undefined
    };
    return {
        success: true,
        result
    };
}

//# sourceMappingURL=stitchPartialResults.js.map